<template>
  <section class="md:pt-16 md:pb-16" :style="{ backgroundColor: sectionBgColor }" aria-labelledby="clarity-guarantee-title">
    <div class="flex-col justify-center items-center px-6 py-10 mx-auto max-w-5xl lg:px-12 md:flex lg:items-center lg:justify-between md:gap-10 lg:flex-row" :style="{ backgroundColor: boxBgColor }">
      <!-- Text content -->
      <div class="lg:w-2/3">
        <h2 id="clarity-guarantee-title" class="text-2xl text-center font-ww-bold xl:text-3xl md:text-2xl" v-html="mainTitle"></h2>
        <div class="mt-4 text-sm text-center md:text-base text-ww-regular xl:text-lg" v-html="description"></div>
      </div>

      <!-- Badge -->
      <div class="flex justify-center mt-8 md:mt-0 md:w-1/3">
        <div>
          <nuxt-img
            :src="badgeImageSrc"
            :alt="badgeImageAlt"
            class="mx-auto w-40 sm:w-40 lg:w-56"
            width="233"
            height="233"
            loading="lazy"
            format="webp"
            sizes="xs:180px sm:180px md:175px lg:233px xl:233px"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  sectionBgColor: {
    type: String,
    default: '#ffffff'
  },
  boxBgColor: {
    type: String,
    default: '#FFF4E1'
  },
  mainTitle: {
    type: String,
    default: 'The 90-Day “Clarity” Guarantee'
  },
  description: {
    type: String,
    default:
      'The high-quality ingredients in Mindflow work synergistically together to support energy, better focus, and clarity. You get all this without the jitters, crashes, and slumps common with low-quality coffees, sugary lattes, and chemical-loaded energy drinks.<br><br>If you don\'t love how you feel and love the taste of Mindflow so much that you hide every bag from your family, including your grandma so they don\'t steal your Mindflow…we\'ll give you a 100% refund.<br><br>Just return the bags, open or unopened, to us anytime in the next 90 days. We\'ll give you a 100% refund. No hassle. No questions. No problems.'
  },
  badgeImageSrc: {
    type: String,
    default: '/assets/images/90-days.png'
  },
  badgeImageAlt: {
    type: String,
    default: '90 Days Risk Free Guarantee'
  }
})

defineBuilderComponent({
  friendlyName: 'Title Text With Icon Banner',
  inputs: [
    { name: 'sectionBgColor', type: 'color', defaultValue: '#ffffff' },
    { name: 'boxBgColor', type: 'color', defaultValue: '#FFF4E1' },
    { name: 'mainTitle', type: 'richText', defaultValue: 'The 90-Day “Clarity” Guarantee' },
    { name: 'description', type: 'richText', defaultValue: 'The high-quality ingredients in Mindflow work synergistically together to support energy, better focus, and clarity. You get all this without the jitters, crashes, and slumps common with low-quality coffees, sugary lattes, and chemical-loaded energy drinks.<br><br>If you don\'t love how you feel and love the taste of Mindflow so much that you hide every bag from your family, including your grandma so they don\'t steal your Mindflow…we\'ll give you a 100% refund.<br><br>Just return the bags, open or unopened, to us anytime in the next 90 days. We\'ll give you a 100% refund. No hassle. No questions. No problems.' },
    { name: 'badgeImageSrc', type: 'file', allowedFileTypes: ['jpeg','jpg','png','webp'], defaultValue: '/assets/images/90-days.png' },
    { name: 'badgeImageAlt', type: 'text', defaultValue: '90 Days Risk Free Guarantee' }
  ]
})
</script>